import { Validators } from "@angular/forms"
import { ITableKey } from "src/app/modules/shared/components/basic-table/basic-table.constants"
import { IFormKey } from "src/app/modules/shared/models/forms"
import { EPolicyTypes } from "src/app/modules/shared/models/policy.model"
import { IOperationPayment } from "../../athora.constants"

export const partial_redeem_form_template = {
    iban: null,
    amount: null,
    authCode: null
}

export const partial_redeem_form_validators = {
    iban: [Validators.required],
    amount: [Validators.required],
    authCode: [Validators.required]
}

export const partial_redeem_form_keys: IFormKey[] = [
    {
        id: 'iban-field',
        label: 'Coordinate bancarie',
        controlName: 'iban',
        css: 'col-4',
        type: 'SELECT',
        options: []
    },
    {
        id: 'auth-code-field',
        label: 'Codice autorizzativo',
        controlName: 'authCode',
        css: 'col-4'
    },
    {
        id: 'amount-field',
        label: 'Importo lordo da liquidare',
        controlName: 'amount',
        css: 'col-4',
        isAmountField: true
    }
]

export interface IRiscattoParzialeRequest {
    policyNumber: string;
    payments: IOperationPayment;
    importoRiscatto?: string;
    importo_CD?: string;
    Importo_V751_GV?: string;
    Importo_V752_GB?: string;
    Importo_V753_GA?: string;
    Importo_V725_CM?: string;
    Importo_V726_CE?: string;
    Importo_V727_CD?: string;
    Importo_GA?: string;
    Importo_GB?: string;
    Importo_CE?: string;
    Importo_FL?: string;
    authorizationCode: string;
    ndgTutoreODelegato?: string;
    codiceLineaCompagnia?: string[];
    controvaloreLineaCompagnia?: string[];
    consultancyAmount: string;
    liquidationSubjects?: any[];
}

export const TYPE_WITH_FUNDS_TABLE = [
    EPolicyTypes.MULTIRAMO,
    EPolicyTypes.UNIT
]

export const PARTIAL_REDEEM_ASSETS_TABLE_TABLE_KEYS: ITableKey[] = [
    {
        key: 'description',
        label: 'Nome fondo'
    },
    {
        key: 'fundAmount',
        label: 'Importo fondo (€)'
    },
    {
        key: 'amount',
        label: 'Importo da disinvestire (€)'
    }
]
